import React from 'react';
import styled from 'styled-components';

// Assuming you have a similar Container component or can adapt these styles
const Wrapper = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  color: #FFFFFF; /* Changed to pure white for better contrast */
  padding: 20px;
  line-height: 1.6;
  font-family: Arial, sans-serif; /* A more readable font for policy */
  max-width: 800px; /* Limit width for better readability */
  margin: 0 auto; /* Center the content */
  box-sizing: border-box; /* Include padding in width calculation */

  @media screen and (max-width: ${({ theme }) => theme.breakpoint || '768px'}) {
    padding: 15px;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: #66CCFF; /* Changed to a bright blue for visibility */
  font-size: 2.5em;
  margin-bottom: 30px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoint || '768px'}) {
    font-size: 2em;
    margin-bottom: 20px;
  }
`;

const SectionTitle = styled.h2`
  color: #66CCFF; /* Changed to a bright blue, matching the title */
  font-size: 1.8em;
  margin-top: 30px;
  margin-bottom: 15px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoint || '768px'}) {
    font-size: 1.5em;
    margin-top: 25px;
    margin-bottom: 10px;
  }
`;

const Paragraph = styled.p`
  margin-bottom: 15px;
  font-size: 1em;
  /* Color defaults to Wrapper's color (#FFFFFF) */

  @media screen and (max-width: ${({ theme }) => theme.breakpoint || '768px'}) {
    font-size: 0.95em;
  }
`;

const UnorderedList = styled.ul`
  margin-bottom: 15px;
  padding-left: 20px;
  list-style-type: disc;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
  font-size: 1em;
  /* Color defaults to Wrapper's color (#FFFFFF) */

  @media screen and (max-width: ${({ theme }) => theme.breakpoint || '768px'}) {
    font-size: 0.95em;
  }
`;

const Emphasis = styled.strong`
  color: #66CCFF; /* Changed to a bright blue for emphasis */
`;

const AppNameStyled = styled.span`
  color: #66CCFF; /* Specific style for app name in text */
`;

const PrivacyPolicy = () => {
  return (
    <Wrapper>
      <Title>Privacy Policy</Title>

      <Paragraph>
        This Privacy Policy governs the manner in which <AppNameStyled>WESO miner</AppNameStyled> (the "App") operates.
        This page informs you of our policies regarding the collection, use, and disclosure of Personal Information
        when you use our App.
      </Paragraph>

      <SectionTitle>No Personal Data Collection</SectionTitle>
      <Paragraph>
        <Emphasis>
          We want to be clear: our App does not collect, store, or transmit any personal data from its users.
        </Emphasis>
        When you use WESO miner, you can do so with the assurance that your personal information,
        device information, or usage habits are not being gathered by us.
      </Paragraph>

      <SectionTitle>No Third-Party Sharing</SectionTitle>
      <Paragraph>
        Since we do not collect any user data, there is no data to share with any third parties.
        Our App operates independently without relying on third-party services that would require data sharing
        for analytics, advertising, or other purposes.
      </Paragraph>

      <SectionTitle>Log Data</SectionTitle>
      <Paragraph>
        We do not collect Log Data. However, please be aware that standard platform services (such as Google Play)
        may collect anonymous, aggregated data for purposes like crash reporting and app performance monitoring.
        This data is generic, does not identify you personally, and is handled by the respective platform provider
        according to their own privacy policies. Our App itself does not log or access this information.
      </Paragraph>

      <SectionTitle>Security</SectionTitle>
      <Paragraph>
        Given that we do not collect any personal data, the primary security concerns related to data breaches
        or unauthorized access are not applicable to our App's direct operations.
        We strive to ensure the App is developed with best practices to prevent vulnerabilities.
      </Paragraph>

      <SectionTitle>Children's Privacy</SectionTitle>
      <Paragraph>
        Our App does not address anyone under the age of 13 ("Children").
        We do not knowingly collect personally identifiable information from children under 13.
        As our App does not collect any personal data from any user, this policy naturally extends to children.
        If you are a parent or guardian and you are aware that your Children have provided us with Personal Information,
        please contact us so that we will be able to do necessary actions.
      </Paragraph>

      <SectionTitle>Changes to This Privacy Policy</SectionTitle>
      <Paragraph>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        These changes are effective immediately after they are posted on this page.
        We encourage you to review this Privacy Policy periodically for any changes.
      </Paragraph>

      <SectionTitle>Contact Us</SectionTitle>
      <Paragraph>
        If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at:
      </Paragraph>
      <UnorderedList>
        <ListItem>
          Email: lbunproject@gmail.com
        </ListItem>
        <ListItem>
          Website: www.wesominer.io
        </ListItem>
      </UnorderedList>
      <Paragraph>
        This Privacy Policy was last updated on: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}.
      </Paragraph>
    </Wrapper>
  );
};

export default PrivacyPolicy;